export default __webpack_public_path__ + "static/media/Slider_2500_Web.e3250cc3.png";